import { updateProviderLocationPatch } from '@/services/api/requests/providers';
import { TUserLocation } from '@/types/User.types';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';

const useUpdateProviderLocations = (onSuccessCallback?: () => void) => {
  const toast = useToast();

  const { isSuccess, isPending, mutate } = useMutation({
    mutationFn: async ({ providerId, locations }: { providerId: string; locations: TUserLocation[] }) => {
      const response = await updateProviderLocationPatch(providerId, locations);
      return response;
    },
    onSuccess: () => {
      toast({
        position: 'top-right',
        status: 'success',
        title: 'Success',
        description: 'Provider Locations successfully updated.',
      });

      onSuccessCallback?.();
    },
    onError: () => {},
  });

  return { isPending, isSuccess, mutate };
};

export default useUpdateProviderLocations;
